import { render } from "./NewAndSolvedTicketsChart.vue?vue&type=template&id=30ccae16&ts=true"
import script from "./NewAndSolvedTicketsChart.vue?vue&type=script&lang=ts"
export * from "./NewAndSolvedTicketsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__